module.exports = __webpack_public_path__ + "static/media/pablo.fcae4f68.jpeg";